import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {
    AiAppEventRendererComponent
} from "../../../../../../../modules/ai/realtime/api/component/aiAppEventRenderer.component";
import {AiRealtimeAppEvent} from "../../../../../../../modules/ai/realtime/api/service/aiRealtime.service";
import {
    MedicalRecordPainConverter
} from "../../../../../../../modules/medical/medical-record/pain/api/converter/medicalRecordPain.converter";
import {
    MedicalRecordPainModel
} from "../../../../../../../modules/medical/medical-record/pain/api/model/medicalRecordPain.model";
import {ConsultationPainItemComponent} from "../consultation-pain-item/consultation-pain-item.component";

@Component({
    selector: 'app-pain-ai-event',
    standalone: true,
    imports: [ConsultationPainItemComponent],
    template: `
    <app-luna-consultation-pain-item
      titleDisplay="title"
      [pain]="pain">
    </app-luna-consultation-pain-item>
  `,
})
export class ConsultationPainAiEventComponent implements AiAppEventRendererComponent, OnChanges {
    static readonly eventName = 'medicalPain';
    pain: MedicalRecordPainModel;

    @Input() event!: AiRealtimeAppEvent;

    constructor(private painConverter: MedicalRecordPainConverter) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.pain = this.painConverter.convert(this.event?.data);
    }
}
